Vue.component('NotificationIndexComponent', require('./components/NotificationsIndexComponent').default);
Vue.component('NotificationComponent', require('./components/NotificationComponent').default);
Vue.component('NotificationAlert', require('./components/NotificationAlert').default);
Vue.component('NotificationModal', require('./components/NotificationModal').default);
// patients
Vue.component(
    'NotificationPatientApprovalRequest',
    require('./components/partials/patients/NotificationPatientApprovalRequest').default
);
Vue.component(
    'NotificationPatientApprovalRequestForm',
    require('./components/partials/patients/NotificationPatientApprovalRequestForm').default
);
// consultants
Vue.component(
    'NotificationConsultantApprovalRequest',
    require('./components/partials/consultants/NotificationConsultantApprovalRequest').default
);
Vue.component(
    'NotificationConsultantApprovalRequestForm',
    require('./components/partials/consultants/NotificationConsultantApprovalRequestForm').default
);
// laboratories
Vue.component(
    'NotificationLaboratoriesApprovalRequest',
    require('./components/partials/laboratories/NotificationLaboratoriesApprovalRequest').default
);
Vue.component(
    'NotificationLaboratoriesApprovalRequestForm',
    require('./components/partials/laboratories/NotificationLaboratoriesApprovalRequestForm').default
);
// cc
Vue.component(
    'NotificationCollectionCentreApprovalRequest',
    require('./components/partials/collectionCentre/NotificationCollectionCentreApprovalRequest').default
);
Vue.component(
    'NotificationCollectionCentresApprovalRequestForm',
    require('./components/partials/collectionCentre/NotificationCollectionCentresApprovalRequestForm').default
);
// PharmacySites
Vue.component(
    'NotificationPharmacySitesApprovalRequest',
    require('./components/partials/pharmacySites/NotificationPharmacySitesApprovalRequest').default
);
Vue.component(
    'NotificationPharmacySitesApprovalRequestForm',
    require('./components/partials/pharmacySites/NotificationPharmacySitesApprovalRequestForm').default
);
// PharmacyGroups
Vue.component(
    'NotificationPharmacyGroupsApprovalRequest',
    require('./components/partials/pharmacyGroups/NotificationPharmacyGroupsApprovalRequest').default
);
Vue.component(
    'NotificationPharmacyGroupsApprovalRequestForm',
    require('./components/partials/pharmacyGroups/NotificationPharmacyGroupsApprovalRequestForm').default
);
